var map = {
	"./brands.js": [
		4785,
		"vendors",
		"src_module_js",
		"src_modules_brands_js"
	],
	"./ingredients.js": [
		2121,
		"vendors",
		"src_module_js",
		"src_modules_ingredients_js"
	],
	"./ingroups.js": [
		7039,
		"vendors",
		"src_module_js",
		"src_modules_ingroups_js"
	],
	"./login.js": [
		2144,
		"vendors",
		"src_module_js",
		"src_modules_login_js"
	],
	"./mappings.js": [
		799,
		"vendors",
		"src_module_js",
		"src_modules_ingredients_js",
		"src_modules_products_js-src_suitability_js",
		"src_modules_mappings_js"
	],
	"./pricelist.js": [
		7398,
		"vendors",
		"src_module_js",
		"src_modules_pricelist_js"
	],
	"./products.js": [
		7846,
		"vendors",
		"src_module_js",
		"src_modules_ingredients_js",
		"src_modules_products_js-src_suitability_js"
	],
	"./prompts.js": [
		5551,
		"vendors",
		"src_module_js",
		"src_modules_prompts_js"
	],
	"./pubs.js": [
		5556,
		"vendors",
		"src_module_js",
		"src_modules_pubs_js"
	],
	"./records.js": [
		2969,
		"vendors",
		"src_module_js",
		"src_modules_records_js"
	],
	"./report.js": [
		4722,
		"vendors",
		"src_module_js",
		"src_modules_report_js"
	],
	"./reviews.js": [
		9134,
		"vendors",
		"src_module_js",
		"src_modules_reviews_js"
	],
	"./search.js": [
		6272,
		"vendors",
		"src_module_js",
		"src_modules_search_js"
	],
	"./service.js": [
		4530,
		"vendors",
		"src_module_js",
		"src_modules_ingredients_js",
		"src_modules_products_js-src_suitability_js",
		"src_modules_service_js"
	],
	"./slides.js": [
		5889,
		"vendors",
		"src_module_js",
		"src_modules_slides_js"
	],
	"./testperfect.js": [
		7324,
		"vendors",
		"src_module_js",
		"src_modules_testperfect_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5825;
module.exports = webpackAsyncContext;